import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-vkforg-list-view',
  imports: [],
  templateUrl: './vkforg.list-view.html',
  styleUrls: ['./vkforg.list-view.css'],
})
export class VkforgListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
